/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import CustomColorDialog from '../dialog/CustomColorDialog';
import CustomPalette from '../dialog/CustomPalette';
import ChangePaletteView from '../views/ChangePaletteView';
import SchematicEditor from '../dialog/SchematicEditor';
import DialogWrapper from '../utilities/DialogWrapper';

import '../../stylesheets/all.scss';

export {
	CustomColorDialog as CustomColorDialog,
	CustomPalette as CustomPalette,
	ChangePaletteView as ChangePaletteView,
	SchematicEditor as SchematicEditor,
	DialogWrapper as DialogWrapper
};



// WEBPACK FOOTER //
// ./src/js/entrypoints/authoring-common.js